import axios from "axios";

// Same-origin in production (FastAPI serves the build); proxied in dev.
const api = axios.create({ baseURL: "/api/v1" });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Cache-buster: evita que el navegador reutilice una respuesta GET vieja
  // (p.ej. la lista de tareas tras crear/editar) sin tener que recargar.
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
    config.headers["Cache-Control"] = "no-cache";
  }
  return config;
});

// Normaliza `err.response.data.detail` a string. FastAPI/Pydantic devuelven
// arrays de errores en 422 (validación); si los pasábamos crudos a un toast,
// React intentaba renderizar el array y podía quedar la pantalla en blanco
// (el caso "crear usuario con clave inválida"). Aquí lo aplanamos a texto
// legible una sola vez, así todos los `push(err.response.data.detail || ...)`
// siguen funcionando sin tocar cada pantalla.
function normalizeErrorDetail(err) {
  const d = err?.response?.data?.detail;
  if (d == null || typeof d === "string") return;
  if (Array.isArray(d)) {
    const msgs = d
      .map((e) => {
        if (!e) return null;
        if (typeof e === "string") return e;
        const field = Array.isArray(e.loc)
          ? e.loc.filter((p) => p !== "body").join(".")
          : "";
        const msg = e.msg || e.message || JSON.stringify(e);
        return field ? `${field}: ${msg}` : msg;
      })
      .filter(Boolean);
    err.response.data.detail = msgs.join(" · ") || "Error de validación";
    return;
  }
  if (typeof d === "object") {
    err.response.data.detail = d.msg || d.message || "Error";
  }
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    normalizeErrorDetail(err);
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("tf_token");
      localStorage.removeItem("tf_user");
      if (!location.pathname.startsWith("/login")) location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
